import { render, staticRenderFns } from "./groupPrecept.vue?vue&type=template&id=699d928e&"
import script from "./groupPrecept.vue?vue&type=script&lang=js&"
export * from "./groupPrecept.vue?vue&type=script&lang=js&"
import style0 from "./groupPrecept.vue?vue&type=style&index=0&id=699d928e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports